import React from 'react';
import { SearchResultContent, type SearchResultContentProps } from './search-result-content';
import { SearchResultLink, type SearchResultLinkProps } from './search-result-link';
import { EnlargedSearchResultContent } from './search-result-content-enlarged';

export interface Props
	extends
		Omit<SearchResultLinkProps, 'children'>,
		Omit<SearchResultContentProps, 'isKeyboardHighlighted' | 'isCollapsed'> {
	isQuickFind?: boolean;
}

/**
 * This component provides a legacy method of rendering search results. It is
 * a composition of SearchResultLink and SearchResultContent.
 */
export const SearchResult = (props: Props): React.JSX.Element => {
	const ResultContentComponent = props.isQuickFind
		? EnlargedSearchResultContent
		: SearchResultContent;
	return (
		<SearchResultLink {...props}>
			{(isKeyboardHighlighted) => (
				<ResultContentComponent {...props} isKeyboardHighlighted={isKeyboardHighlighted} />
			)}
		</SearchResultLink>
	);
};
